module.exports = __webpack_public_path__ + "img/pfondo2.a25ed07b.png";